<template>
    <el-dialog :title="titleName" :visible.sync="dialogFormVisible">
        <el-form :model="form" :rules="rules" ref="ruleForm">
            <el-input v-model="form.id" autocomplete="off" style="display: none;"></el-input>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="科目分类" :label-width="formLabelWidth" :required="true" prop="leiBie">
                        <el-select
                                :disabled="isView || form.pzCount >0 "
                                style="width: 100%"
                                @change="getAllKmList"
                                v-model="form.leiBie"
                                placeholder="科目分类"
                                clearable>
                            <el-option label="资产" value="ZC"/>
                            <el-option label="负债" value="FZ"/>
                            <el-option label="权益" value="QY"/>
                            <el-option label="成本" value="CB"/>
                            <el-option label="损益" value="SY"/>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <!--科目名称-->
                    <el-input v-model="form.kmLbName" style="display: none" autocomplete="off"></el-input>
                    <el-form-item label="科目类别" :label-width="formLabelWidth" :required="true" prop="kmLbCode">
                        <el-select
                                :disabled="isView || form.pzCount >0 "
                                style="width: 100%"
                                v-model="form.kmLbCode"
                                placeholder="科目类别"
                                clearable>

                            <el-option label="流动资产" value="101" v-if="form.leiBie==='ZC'"/>
                            <el-option label="非流动资产" value="102" v-if="form.leiBie==='ZC'"/>

                            <el-option label="流动负债" value="201" v-if="form.leiBie==='FZ'"/>
                            <el-option label="非流动负债" value="202" v-if="form.leiBie==='FZ'"/>

                            <el-option label="所有者权益" value="301" v-if="form.leiBie==='QY'"/>

                            <el-option label="成本" value="401" v-if="form.leiBie==='CB'"/>

                            <el-option label="营业收入" value="501" v-if="form.leiBie==='SY'"/>
                            <el-option label="其他收益" value="502" v-if="form.leiBie==='SY'"/>
                            <el-option label="期间费用" value="503" v-if="form.leiBie==='SY'"/>
                            <el-option label="其他损失" value="504" v-if="form.leiBie==='SY'"/>
                            <el-option label="营业成本及税金" value="505" v-if="form.leiBie==='SY'"/>
                            <el-option label="以前年度损益调整" value="506" v-if="form.leiBie==='SY'"/>
                            <el-option label="所得税" value="507" v-if="form.leiBie==='SY'"/>

                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="科目编码" :label-width="formLabelWidth" :required="true" prop="dicCode">
                        <el-input v-model="form.dicCode" :disabled="isView || form.pzCount >0 " autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="科目名称" :label-width="formLabelWidth" :required="true" prop="dicName">
                        <el-input v-model="form.dicName" :disabled="isView" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-input v-model="form.parentDicName" style="display: none" autocomplete="off"></el-input>
                    <el-form-item label="父级科目" :label-width="formLabelWidth">
                        <el-select clearable style="width: 100%" v-model="form.parentDicCode" :disabled="isView || form.pzCount >0 " clearable filterable placeholder="父级类别名称">
                            <el-option v-for="item in lbKmList" :key="item.dicCode"
                                       :label="item.dicCode+' '+item.dicName" :value="item.dicCode"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="余额方向" :label-width="formLabelWidth" :required="true" prop="yueFx">
                        <el-radio-group v-model="form.yueFx" :disabled="isView || form.pzCount >0 ">
                            <el-radio key="1" label="1" value="1">借</el-radio>
                            <el-radio key="-1" label="-1" value="-1">贷</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24">

                    <el-checkbox v-model="form.needFz" :disabled="isView || form.pzCount >0 " style="float: left;margin-left: 20px;">辅助核算</el-checkbox>

                    <el-checkbox-group v-model="form.fzList" :disabled="isView || form.pzCount >0 " v-if="form.needFz" style="float: left;margin-left: 30px;">
                        <el-checkbox v-for="item in fuZhuTypeList" :label="item.id" :key="item.id">{{item.fna}}</el-checkbox>
                    </el-checkbox-group>

                </el-col>
            </el-row>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
            <el-button size="mini" type="primary" @click="addAndUpdate('ruleForm')" v-if="!isView">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                dialogFormVisible: true,
                isView: false,
                url: '',
                titleName: '',
                lbKmList: [],
                fuZhuTypeList: [],
                form: {
                    id: '',
                    dicCode: '',
                    dicName: '',
                    parentDicCode: '',
                    parentDicName: '',
                    levelDicCode: '',
                    levelDicId: '',
                    isDelete: '',
                    levelNum: '',
                    fullName: '',
                    status: '1',
                    createTime: '',
                    updateTime: '',
                    leiBie: 'ZC',
                    yueFx: '',
                    kmLbCode: '',
                    kmLbName: '',
                    needFz: false,
                    fzList:[]
                },
                rules: {
                    id: [{required: true, message: '请输入主键ID', trigger: 'blur'}],
                    dicCode: [{required: true, message: '请输入科目代码', trigger: 'blur'}],
                    dicName: [{required: true, message: '请输入科目名称', trigger: 'blur'}],
                    parentDicCode: [{required: true, message: '请输入上级代码', trigger: 'blur'}],
                    parentDicName: [{required: true, message: '请输入上级名称', trigger: 'blur'}],
                    levelDicCode: [{required: true, message: '请输入层级代码', trigger: 'blur'}],
                    levelDicId: [{required: true, message: '请输入层级ID', trigger: 'blur'}],
                    isDelete: [{required: true, message: '请输入1：正常、-1：已删除', trigger: 'blur'}],
                    levelNum: [{required: true, message: '请输入层级数', trigger: 'blur'}],
                    fullName: [{required: true, message: '请输入完整层级科目名称', trigger: 'blur'}],
                    status: [{required: true, message: '请输入启用状态，1：启用，2：停用', trigger: 'blur'}],
                    createTime: [{required: true, message: '请输入创建时间', trigger: 'blur'}],
                    updateTime: [{required: true, message: '请输入更新时间', trigger: 'blur'}],
                    leiBie: [{required: true, message: '请输入科目分类 ZC:资产、FZ:负债、QY:权益、CB:成本、SY:损益', trigger: 'blur'}],
                    yueFx: [{required: true, message: '请输入余额方向 1:借  -1：贷', trigger: 'blur'}],
                    kmLbCode: [{required: true, message: '请输入科目类别代码', trigger: 'blur'}],
                    kmLbName: [{required: true, message: '请输入科目类别名称', trigger: 'blur'}]
                },
                formLabelWidth: '90px'
            };
        },
        methods: {
            int(type, id, dicCode, liebie) {

                this.isView = false;

                this.$refs['ruleForm'].resetFields();
                this.dialogFormVisible = true;
                this.form.id = '';
                this.form.dicCode = '';
                this.form.dicName = '';
                this.form.parentDicCode = dicCode;
                this.form.parentDicName = '';
                this.form.levelDicCode = '';
                this.form.levelDicId = '';
                this.form.isDelete = '';
                this.form.levelNum = '';
                this.form.fullName = '';
                this.form.status = '1';
                this.form.createTime = '';
                this.form.updateTime = '';
                this.form.leiBie = liebie;
                this.form.yueFx = '';
                this.form.kmLbCode = '';
                this.form.kmLbName = '';

                this.form.needFz = false;
                this.form.fzList = [];

                this.getAllKmList(this.form.leiBie)
                this.getFuZhuTypeList();

                if (type == '1') {
                    this.titleName = "科目表-新增";
                    this.url = "/business/dicKm/save";
                } else {
                    if (type == '2') {
                        this.titleName = "科目表-修改";
                    }else if (type == '3') {
                        this.isView = true;
                        this.titleName = "科目表-详情";
                    }

                    this.url = "/business/dicKm/update";
                    this.$httpTAG({
                        url: this.$httpTAG.adornUrl('/business/dicKm/view'),
                        method: 'post',
                        data: this.$httpTAG.adornData({
                            'id': id
                        })
                    }).then(r => {
                        this.form = r.data.data;
                    }).finally(r => {
                    })
                }
            },
            getFuZhuTypeList() {
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/fuZhuXm/allList'),
                    method: 'get'
                }).then(r => {
                    this.fuZhuTypeList = r.data.data;
                })
            },
            getAllKmList(leiBie) {
                this.form.kmLbCode = '';
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/dicKm/getAllKmList'),
                    method: 'post',
                    data: this.$httpTAG.adornData({
                        'leiBie': leiBie
                    })
                }).then(r => {
                    this.lbKmList = r.data.data;
                }).finally(r => {
                })
            },
            addAndUpdate(formName) {

                if(this.form.kmLbCode == '101'){
                    this.form.kmLbName = '流动资产';
                }else if(this.form.kmLbCode == '102'){
                    this.form.kmLbName = '非流动资产';
                }else if(this.form.kmLbCode == '201'){
                    this.form.kmLbName = '流动负债';
                }else if(this.form.kmLbCode == '202'){
                    this.form.kmLbName = '非流动负债';
                }else if(this.form.kmLbCode == '301'){
                    this.form.kmLbName = '所有者权益';
                }else if(this.form.kmLbCode == '401'){
                    this.form.kmLbName = '成本';
                }else if(this.form.kmLbCode == '501'){
                    this.form.kmLbName = '营业收入';
                }else if(this.form.kmLbCode == '502'){
                    this.form.kmLbName = '其他收益';
                }else if(this.form.kmLbCode == '503'){
                    this.form.kmLbName = '期间费用';
                }else if(this.form.kmLbCode == '504'){
                    this.form.kmLbName = '其他损失';
                }else if(this.form.kmLbCode == '505'){
                    this.form.kmLbName = '营业成本及税金';
                }else if(this.form.kmLbCode == '506'){
                    this.form.kmLbName = '以前年度损益调整';
                }else if(this.form.kmLbCode == '507'){
                    this.form.kmLbName = '所得税';
                }

                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$httpTAG({
                            url: this.$httpTAG.adornUrl(this.url),
                            method: 'post',
                            data: this.$httpTAG.adornData({
                                ...this.form
                            })
                        }).then(res => {
                            if (res.data.code == 0) {
                                this.$notify({
                                    title: '操作成功！',
                                    type: 'success',
                                    offset: 600
                                });
                                this.dialogFormVisible = false
                                this.$emit("getMgrTree", this.form.leiBie);
                            } else {
                                this.$message({ // 失败
                                    type: 'fail',
                                    message: res.data.msg
                                })
                            }
                        })
                    }

                })
            }
        },
        created() {

        }
    }

</script>

<style scoped>
</style>
